export const environment = {
  production: true,
  apiUrl: '#{apiUrl}',
  sessionFormWizardDataModelKey: '#{sessionFormWizardDataModelKey}',
  sessionIdKey: 'session-id',
  // the mail address that will be presented to the user when an unrecoverable error occurs.
  errorMailTo: '#{errorMailTo}',
  vegSpatialCategoryLayerId: 8,
  vegSpatialRegionalEcosystemLayerId: 9,
  vegBiotaEssentialHabitatLayerId: 5,
  vegBiotaWaterCourseLayerId: 7,
  vegBiotaWetLandLayerId: 4,
  vegSpatialFeatureLayerUrl : '#{vegSpatialFeatureLayerUrl}',
  vegSpatialServerRootUrl: '#{vegSpatialServerRootUrl}',
  vegSpatialAddressTypeAheadURL: '#{vegSpatialAddressTypeAheadURL}',
  vegSpatialAddressURL: '#{vegSpatialAddressURL}',
  vegSpatialLotplanMapURL: '#{vegSpatialLotplanMapURL}',
  vegSpatialLotplanbupURL: '#{vegSpatialLotplanbupURL}',
  featureClientEnableNFP2019Code: '#{featureClientEnableNFP2019Code}'.toLowerCase() === 'true',
  featureShowFrontPageBanner: '#{featureShowFrontPageBanner}'.toLowerCase() === 'true'
};
